import { PathPoint } from './path-point';
import { BoPathTrjMatInterface } from '../../../interface/back-office/path/path-trj/bo-path-trj-mat.interface';

export class PathPointMat extends PathPoint {
  public bbx: string;
  public date: string;

  constructor(o: BoPathTrjMatInterface) {
    super(o);
    this.bbx = o.bbx;
    this.date = o.date;
  }
}
